import { Client } from "./_clientService";

async function getDailyRewardCycles(
  options: { pageNo?: number; pageSize?: number } = {},
) {
  const resp = await new Client({
    path: "/daily-reward-cycle/list",
    payload: { pageNo: options.pageNo ?? 1, limit: options.pageSize ?? 10 },
  }).post();

  return resp;
}

async function getDailyRewardCycleInfo(id: string) {
  const resp = await new Client({
    path: "/daily-reward-cycle/info",
    payload: { id },
  }).post();

  return resp;
}

async function createDailyRewardCycle(payload: any) {
  const resp = await new Client({
    path: "/daily-reward-cycle/create",
    payload,
  }).post();

  return resp;
}

async function updateDailyRewardCycle(payload: any) {
  const resp = await new Client({
    path: "/daily-reward-cycle/update",
    payload,
  }).post();

  return resp;
}

async function updateDailyRewardCycleStatus(id: string) {
  const resp = await new Client({
    path: "/daily-reward-cycle/status",
    payload: { id },
  }).post();

  return resp;
}

async function deleteDailyRewardCycle(id: string) {
  const resp = await new Client({
    path: "/daily-reward-cycle/delete",
    payload: { id },
  }).post();

  return resp;
}

async function uploadSlotImage(
  file: File,
  dimensions?: { targetWidth?: number; targetHeight?: number } | null,
) {
  const formData = new FormData();
  formData.append("image", file);

  if (dimensions?.targetWidth) {
    formData.append("resizeToWidth", String(dimensions.targetWidth));
  }
  if (dimensions?.targetHeight) {
    formData.append("resizeToHeight", String(dimensions.targetHeight));
  }

  const resp = await new Client({
    path: "/daily-reward-cycle/slot-image/upload",
    payload: formData,
  }).post();

  return resp?.data as { imagePath: string; imageUrl: string | null };
}

export {
  createDailyRewardCycle,
  deleteDailyRewardCycle,
  getDailyRewardCycleInfo,
  getDailyRewardCycles,
  updateDailyRewardCycle,
  updateDailyRewardCycleStatus,
  uploadSlotImage,
};
